const REDIRECT_URL_STORAGE_KEY = 'auth.redirectUrl';

export function normalizeRedirectUrl (redirectUrl) {
    if (typeof redirectUrl !== 'string') {
        return null;
    }

    const value = redirectUrl.trim();

    if (!value) {
        return null;
    }

    try {
        const url = new URL(value, window.location.origin);

        if (url.origin !== window.location.origin) {
            return null;
        }

        return `${url.pathname}${url.search}${url.hash}`;
    } catch (e) {
        return null;
    }
}

export function storeRedirectUrl (redirectUrl) {
    const normalizedRedirectUrl = normalizeRedirectUrl(redirectUrl);

    if (!normalizedRedirectUrl) {
        sessionStorage.removeItem(REDIRECT_URL_STORAGE_KEY);

        return null;
    }

    sessionStorage.setItem(REDIRECT_URL_STORAGE_KEY, normalizedRedirectUrl);

    return normalizedRedirectUrl;
}

export function clearStoredRedirectUrl () {
    sessionStorage.removeItem(REDIRECT_URL_STORAGE_KEY);
}

export function consumeStoredRedirectUrl () {
    const redirectUrl = normalizeRedirectUrl(sessionStorage.getItem(REDIRECT_URL_STORAGE_KEY));

    clearStoredRedirectUrl();

    return redirectUrl;
}
